<template>
  <div>
    <!-- SEO Head -->
    <SEOHead 
      title="Web Services - Thiết kế website chuyên nghiệp tại Việt Nam"
      description="Dịch vụ thiết kế website chuyên nghiệp tại Việt Nam. Tối ưu SEO, tốc độ cao, giao diện responsive. Hotline: 0905 514 868"
      keywords="thiết kế website, website chuyên nghiệp, SEO, responsive, Vue.js, Node.js, Việt Nam"
      url="https://webservices.vn"
      type="website"
    />
    
    <!-- Schema Markup -->
    <SchemaMarkup 
      type="Organization"
      :data="organizationSchema"
    />
    <SchemaMarkup 
      type="WebSite"
      :data="websiteSchema"
    />
    
    <Slogan/>
    <Background/>
    <Services/>
    <SupportField/>
    <FAQ/>
    <ClientSay/>
    <CTA/>
    <!-- <OurTeam/> -->
    <!-- <ElectronApp/> -->
  </div>
</template>
<script setup>
import Slogan from '../components/Slogan.vue';
import Background from '../components/Background.vue';
import Services from '../components/Services.vue';
import SupportField from '../components/SupportField.vue';
import FAQ from "../components/FAQ.vue";
import ClientSay from "../components/ClientSay.vue";
import CTA from "../components/CTA.vue";
import SEOHead from '../components/SEOHead.vue';
import SchemaMarkup from '../components/SchemaMarkup.vue';
// import OurTeam from "../components/OurTeam.vue";
// import ElectronApp from "../components/ElectronApp.vue";

// Schema data
const organizationSchema = {
  name: 'Web Services',
  url: 'https://webservices.vn',
  logo: 'https://webservices.vn/favicon.webp',
  description: 'Dịch vụ thiết kế website chuyên nghiệp tại Việt Nam. Tối ưu SEO, tốc độ cao, giao diện responsive.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'VN',
    addressRegion: 'Hồ Chí Minh',
    addressLocality: 'TP. Hồ Chí Minh'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+84-905-514-868',
    contactType: 'customer service',
    availableLanguage: ['Vietnamese', 'English']
  },
  sameAs: [
    'https://www.facebook.com/webservices.vn',
    'https://www.linkedin.com/company/webservices-vn'
  ],
  foundingDate: '2020',
  numberOfEmployees: '5-10',
  serviceArea: {
    '@type': 'Country',
    name: 'Vietnam'
  }
};

const websiteSchema = {
  name: 'Web Services - Thiết kế website chuyên nghiệp',
  url: 'https://webservices.vn',
  description: 'Dịch vụ thiết kế website chuyên nghiệp tại Việt Nam. Tối ưu SEO, tốc độ cao, giao diện responsive.',
  publisher: {
    '@type': 'Organization',
    name: 'Web Services',
    url: 'https://webservices.vn'
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://webservices.vn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string'
  }
};
</script>
<style scoped>

</style>
